import { useMutation } from '@tanstack/react-query';
import apiService from './apiServices';
import { apiServiceRTQ } from './apiShow';

interface PostApiProps {
  url: string;
  onSuccess?: () => void;
}

interface MutationValues {
  [key: string]: any;
}

interface MutationResponse {
  data: any;
}

export const usePostApi = ({ url, onSuccess }: PostApiProps) => {
  return useMutation<MutationResponse, Error, MutationValues>({
    mutationFn: (values: MutationValues) => apiServiceRTQ.post(url, values),
    onSuccess: (data: MutationResponse) => {
      onSuccess && onSuccess();
    },
    onError: (error: Error) => {},
  });
};

export const usePostExcelGeneratorApi = () => {
  return useMutation<MutationResponse, Error, PostApiProps>({
    mutationFn: ({ url, values, onSuccess }: PostApiProps) =>
      apiServiceRTQ.post(url, values, { showToast: true }),
    // onSuccess: (data: MutationResponse) => {
    //   onSuccess && onSuccess();
    // },
    onError: (error: Error) => {},
  });
};
